import styled from 'styled-components';

import { IOptionContainer } from './types';

const OptionContainer = styled.div<IOptionContainer>`
  background-color: ${Styles.color.cardBackground};
  border: 0;
  border-radius: ${Styles.borderRadius};
  color: ${p => (p.disabled ? Styles.color.grey.three : Styles.color.black)};
  font-size: 0.9375rem;
  font-family: ${Styles.fontFamily.body};
  justify-content: center;
  margin: 5px 0;
  padding: 12px;
  padding-right: 24px;

  ${Styles.mobileTiny`
    padding-right: 12px;
  `}

  ${Styles.desktop`
    padding: 18px;
    padding-right: 34px;
  `}
`;

export default OptionContainer;
